import { CrudModel } from './_crud';

export class CompanyModel extends CrudModel {
	constructor() {
		super('app/company');
	}
}

export default new CompanyModel();
